<div class="bgclass">
    <app-ribbon *ngIf="!hideRibbonSig()"></app-ribbon>
    <router-outlet></router-outlet>
</div>
